export type ToastSeverity = "success" | "error" | "warning" | "info";

type ToastListener = (message: string, severity: ToastSeverity) => void;

let listener: ToastListener | null = null;

export const toastEmitter = {
  subscribe: (fn: ToastListener) => {
    listener = fn;
  },
  unsubscribe: () => {
    listener = null;
  },
  show: (message: string, severity: ToastSeverity = "error") => {
    if (listener) {
      listener(message, severity);
    } else {
      console.warn(`[Toast][${severity}]`, message);
    }
  },
};
